import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckIcon from '@mui/icons-material/Check';
import { TreeItemLabelInput } from '@mui/x-tree-view/TreeItemLabelInput';
import React from 'react';
import { UseTreeItemLabelInputSlotOwnProps } from '@mui/x-tree-view';

interface TCustomLabelInputProps extends UseTreeItemLabelInputSlotOwnProps {
  handleCancelItemLabelEditing: (event: React.SyntheticEvent) => void;
  handleSaveItemLabel: (event: React.SyntheticEvent, label: string | undefined) => void;
  value?: string;
}

const CustomLabelInput = (props: TCustomLabelInputProps) => {
  const { handleCancelItemLabelEditing, handleSaveItemLabel, value, ...other } =
    props;

  // Enter saves (same as clicking the green checkmark); Escape cancels.
  // Both stopPropagation so the tree's row handlers don't swallow the
  // keystroke as e.g. expand/collapse.
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      handleSaveItemLabel(e, value);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      handleCancelItemLabelEditing(e);
    }
  };

  return (
    <React.Fragment>
      <TreeItemLabelInput {...other} value={value} onKeyDown={handleKeyDown} />
      <IconButton
        color="success"
        size="small"
        aria-label="Save"
        onClick={(event) => {
          event.stopPropagation();
          handleSaveItemLabel(event, value);
        }}
      >
        <CheckIcon fontSize="small" />
      </IconButton>
      <IconButton
        color="error"
        size="small"
        aria-label="Cancel"
        onClick={(e) => {
          e.stopPropagation();
          handleCancelItemLabelEditing(e);
        }}
      >
        <CloseRoundedIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
};

export default CustomLabelInput;
